import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlusCircle } from "lucide-react";
import axios from "axios";
import { V_URL } from "../../../../../../BaseUrl";
import { getGenMaster } from "../../../../../../Store/Store/GenralMaster/GenMaster";
import GenMasterModal from "../../../../../../Components/Item/GenMasterModal";
import toast from "react-hot-toast";

const IssueFields = ({
  form,
  handleChange,
  setForm,
  error,
  data,
  departmentData = [],
  locationData = [],
}) => {
  const dispatch = useDispatch();

  // All genmaster items (used for tag_id lookup and dropdown options)
  const issueByData =
    useSelector((state) => state.getGenMaster?.user?.data) || [];

  // Modal state: { receivedBy, authorisedBy, takenBy }
  const [modal, setModal] = useState({
    receivedBy: false,
    authorisedBy: false,
    takenBy: false,
  });

  const [modalName, setModalName] = useState({
    receivedBy: "",
    authorisedBy: "",
    takenBy: "",
  });

  const [modalError, setModalError] = useState({
    receivedBy: "",
    authorisedBy: "",
    takenBy: "",
  });

  const [modalDisable, setModalDisable] = useState({
    receivedBy: false,
    authorisedBy: false,
    takenBy: false,
  });

  const openModal = (key) =>
    setModal((prev) => ({ ...prev, [key]: true }));

  const closeModal = (key) => {
    setModal((prev) => ({ ...prev, [key]: false }));
    setModalName((prev) => ({ ...prev, [key]: "" }));
    setModalError((prev) => ({ ...prev, [key]: "" }));
  };

  // tag_number mapping: 19 = Received By, 18 = Authorised By, 20 = Taken By
  const TAG_MAP = {
    receivedBy: { tagNumber: 19, formField: "received_by_id", isArray: true },
    authorisedBy: { tagNumber: 18, formField: "authorised_id", isArray: false },
    takenBy: { tagNumber: 20, formField: "taken_by_id", isArray: true },
  };

  const handleGenMasterSubmit = (key) => {
    const name = modalName[key]?.trim();
    if (!name) {
      setModalError((prev) => ({ ...prev, [key]: "Please enter name" }));
      return;
    }

    const { tagNumber, formField, isArray } = TAG_MAP[key];

    // Resolve tag_id: use tag_id from an existing genmaster item of this category.
    // Each genmaster item stores its parent tag's _id in the tag_id field.
    const existingItem = issueByData.find((item) => item.tag_number === tagNumber);
    const resolvedTagId = existingItem?.tag_id;

    if (!resolvedTagId) {
      toast.error(
        "No existing entries found for this field. Please create one first via General Master."
      );
      return;
    }

    setModalDisable((prev) => ({ ...prev, [key]: true }));

    const formData = new URLSearchParams();
    formData.append("name", name);
    formData.append("tag_id", resolvedTagId);

    axios({
      method: "post",
      url: `${V_URL}/user/manage-master`,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((res) => {
        if (res.data.success === true) {
          toast.success(res.data.message);
          const newId = res.data.data?._id;
          dispatch(getGenMaster({})).then(() => {
            if (newId && setForm) {
              setForm((prev) => ({
                ...prev,
                [formField]: isArray
                  ? [...(prev[formField] || []), newId]
                  : newId,
              }));
            }
          });
          closeModal(key);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setModalDisable((prev) => ({ ...prev, [key]: false }));
      });
  };
  // const projectData =
  //   useSelector((state) => state.getProject?.user?.data) || [];
  // const partyData = useSelector((state) => state.getParty?.user?.data) || [];
  // const transportData =
  //   useSelector((state) => state.getTransport?.user?.data) || [];
  // const paidByData = [
  //   {
  //     label: "Owner",
  //     value: "owner",
  //   },
  //   {
  //     label: "Party",
  //     value: "party",
  //   },
  // ];

  const statusData = [
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 4 },
  ];

  // const selectedProject = projectData.find(
  //   (p) => p._id === form.project_id
  // );

  const receivedByOptions = issueByData.filter((rev) => rev.tag_number === 19)
  const authoRisedByOptions = issueByData.filter((rev) => rev.tag_number === 18)
  const takenByOptions = issueByData.filter((rev) => rev.tag_number === 20)

  return (
    <>
      <div className="row">
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Project <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "project_id", value: e.value } })
              }
              placeholder="Select Project"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.project_id}</div>
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Project No</label>
              <input
                type="text"
                name="manual_pro_no"
                value={form?.manual_pro_no || ""}
                onChange={handleChange}
                placeholder="Enter Project No"
                className="form-control"
              />
            </div>
          </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Party <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.party_id}
              options={partyData?.map((e) => ({ label: e.name, value: e._id }))}
              onChange={(e) =>
                handleChange({ target: { name: "party_id", value: e.value } })
              }
              placeholder="Select Party"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.party_id}</div>
          </div>
        </div> */}
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Issue No.</label>
              <input
                type="text"
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="trans_date"
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && (
              <div className="error">{error.trans_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Issue Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="receive_date"
              onChange={handleChange}
              value={form.receive_date}
            />
            {error.receive_date && (
              <div className="error">{error.receive_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Bill No. <span className="login-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="bill_no"
              onChange={handleChange}
              value={form.bill_no}
            // disabled
            />
            {error.bill_no && <div className="error">{error.bill_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Received By <span className="login-danger">*</span>
            </label>
            <div className="d-flex gap-2">
              <div className="flex-grow-1">
                <MultiSelect
                  value={form.received_by_id || []}
                  options={receivedByOptions?.map((e) => ({
                    label: e.name,
                    value: e._id,
                  }))}
                  onChange={(e) =>
                    handleChange({ target: { name: "received_by_id", value: e.value } })
                  }
                  placeholder="Select Received By"
                  filter
                  maxSelectedLabels={3}
                  className="w-100 multi-prime-react"
                />
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "38px" }}
                title="Add Received By"
                onClick={() => openModal("receivedBy")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
            {error.received_by_id && <div className="error">{error.received_by_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Authorised By <span className="login-danger">*</span>
            </label>
            <div className="d-flex gap-2">
              <div className="flex-grow-1">
                <Dropdown
                  value={form.authorised_id}
                  options={authoRisedByOptions?.map((e) => ({
                    label: e.name,
                    value: e._id,
                  }))}
                  onChange={(e) =>
                    handleChange({ target: { name: "authorised_id", value: e.value } })
                  }
                  placeholder="Select Authorised By"
                  filter
                  className="w-100"
                />
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "38px" }}
                title="Add Authorised By"
                onClick={() => openModal("authorisedBy")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
            {error.authorised_id && <div className="error">{error.authorised_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Taken By <span className="login-danger">*</span>
            </label>
            <div className="d-flex gap-2">
              <div className="flex-grow-1">
                <MultiSelect
                  value={form.taken_by_id || []}
                  options={takenByOptions?.map((e) => ({
                    label: e.name,
                    value: e._id,
                  }))}
                  onChange={(e) =>
                    handleChange({ target: { name: "taken_by_id", value: e.value } })
                  }
                  placeholder="Select Taken By"
                  filter
                  maxSelectedLabels={3}
                  className="w-100 multi-prime-react"
                />
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "38px" }}
                title="Add Taken By"
                onClick={() => openModal("takenBy")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
            {error.taken_by_id && <div className="error">{error.taken_by_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Department </label>
            <Dropdown
              value={form.department_id}
              options={departmentData?.map((d) => ({
                label: d.name,
                value: d._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "department_id", value: e.value },
                })
              }
              showClear
              filter
              placeholder="Select Department"
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Store Location</label>
            <Dropdown
              value={form.store_location_id}
              options={locationData?.map((l) => ({
                label: l.name,
                value: l._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "store_location_id", value: e.value },
                })
              }
              showClear
              filter
              placeholder="Select Store Location"
              className="w-100"
            />
          </div>
        </div>
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              {" "}
              Transport <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.transport_id}
              options={transportData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "transport_id", value: e.value },
                })
              }
              placeholder="Select Transport"
              filter
              className="w-100"
            />
            {error.transport_id && (
              <div className="error">{error.transport_id}</div>
            )}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Transport Date </label>
            <input
              type="date"
              className="form-control"
              name="transport_date"
              onChange={handleChange}
              value={form.transport_date}
            />
            {error.transport_date && (
              <div className="error">{error.transport_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Transport Charges </label>
            <input
              type="number"
              className="form-control"
              name="transport_charges"
              onChange={handleChange}
              value={form.transport_charges}
            />
            {error.transport_charges && (
              <div className="error">{error.transport_charges}</div>
            )}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> LR No. </label>
            <input
              type="text"
              className="form-control"
              name="lr_no"
              onChange={handleChange}
              value={form.lr_no}
            />
            {error.lr_no && <div className="error">{error.lr_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>LR Date</label>
            <input
              type="date"
              className="form-control"
              name="lr_date"
              onChange={handleChange}
              value={form.lr_date}
            />
            {error.lr_date && <div className="error">{error.lr_date}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Vehicle No.</label>
            <input
              type="text"
              className="form-control"
              name="vehical_no"
              onChange={handleChange}
              value={form.vehical_no}
            />
            {error.vehical_no && (
              <div className="error">{error.vehical_no}</div>
            )}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label> Paid By</label>
            <Dropdown
              value={form.paid_by}
              options={paidByData}
              onChange={(e) =>
                handleChange({ target: { name: "paid_by", value: e.value } })
              }
              placeholder="Select Paid By"
              filter
              className="w-100"
            />
            {error.paid_by && <div className="error">{error.paid_by}</div>}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Gate Pass</label>
            <input
              type="text"
              className="form-control"
              name="get_pass"
              onChange={handleChange}
              value={form.get_pass}
            />
            {error.get_pass && <div className="error">{error.get_pass}</div>}
          </div>
        </div> */}

        {data?._id && data?.status === 4 && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms custom-select-wpr">
              <label>Status</label>
              <Dropdown
                value={form.status}
                options={statusData}
                onChange={(e) =>
                  handleChange({ target: { name: "status", value: e.value } })
                }
                placeholder="Select Status"
                className="w-100"
                showClear
              />
            </div>
          </div>
        )}

        <div className="col-12 ">
          <div className="input-block local-forms">
            <label>Reason/Purpose</label>
            <textarea
              type="text"
              className="form-control"
              onChange={handleChange}
              name="remarks"
              value={form.remarks}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="input-block local-forms">
            <label>Address</label>
            <textarea
              type="text"
              className="form-control"
              name="address"
              onChange={handleChange}
              value={form.address}
            />
            {error.address && <div className="error">{error.address}</div>}
          </div>
        </div>
      </div>
      {/* GenMaster Modals */}
      <GenMasterModal
        show={modal.receivedBy}
        onClose={() => closeModal("receivedBy")}
        title="Received By"
        name={modalName.receivedBy}
        setName={(val) =>
          setModalName((prev) => ({ ...prev, receivedBy: val }))
        }
        nameError={modalError.receivedBy}
        onSubmit={() => handleGenMasterSubmit("receivedBy")}
        disableSubmit={modalDisable.receivedBy}
      />

      <GenMasterModal
        show={modal.authorisedBy}
        onClose={() => closeModal("authorisedBy")}
        title="Authorised By"
        name={modalName.authorisedBy}
        setName={(val) =>
          setModalName((prev) => ({ ...prev, authorisedBy: val }))
        }
        nameError={modalError.authorisedBy}
        onSubmit={() => handleGenMasterSubmit("authorisedBy")}
        disableSubmit={modalDisable.authorisedBy}
      />

      <GenMasterModal
        show={modal.takenBy}
        onClose={() => closeModal("takenBy")}
        title="Taken By"
        name={modalName.takenBy}
        setName={(val) =>
          setModalName((prev) => ({ ...prev, takenBy: val }))
        }
        nameError={modalError.takenBy}
        onSubmit={() => handleGenMasterSubmit("takenBy")}
        disableSubmit={modalDisable.takenBy}
      />
    </>
  );
};

export default IssueFields;
